import * as ConnectActions from '../../../store/shipstation-connect/ss-connect.actions';
import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';
import * as Actions from './bulk.update.actions';
import get from 'lodash.get';

const drawerBulkUpdateJobId = 'drawer-bulk-update';

const initialState = {
  jobIdtoJobMap: {},
  lastAddedJobId: '',
};

const updateBulkJobId = (state, bulkUpdateJobId, updateProperties) => {
  const { jobIdtoJobMap } = state;
  const currentJob = jobIdtoJobMap[bulkUpdateJobId];
  if (!currentJob) {
    return state;
  }
  return {
    ...state,
    jobIdtoJobMap: {
      ...jobIdtoJobMap,
      [bulkUpdateJobId]: {
        ...currentJob,
        ...updateProperties,
      },
    },
  };
};

const startJob = (state, { bulkUpdateTypeData, bulkActions, ids, id, source }) => {
  const { jobIdtoJobMap } = state;
  return {
    ...state,
    jobIdtoJobMap: {
      ...jobIdtoJobMap,
      [id]: {
        id,
        bulkUpdateTypeData,
        bulkActions,
        ids,
        model: {},
        isLoading: true,
        source,
      },
    },
    lastAddedJobId: id,
  };
};

const actionHandlerMap = {
  [Actions.START_BULK_UPDATE_JOB]: (state, action) => startJob(state, action),
  [Actions.START_BULK_UPDATE_JOB_FROM_DRAWER]: (state, action) => startJob(state, action),
  [Actions.START_BULK_UPDATE_DO_NOT_NOTIFY_MARKETPLACE_JOB]: (state, action) => startJob(state, action),
  [Actions.BULK_UPDATE_GET_JOB_DATA_SUCCESS]: (state, { bulkUpdateJobId, bulkUpdateJobData }) => {
    return updateBulkJobId(state, bulkUpdateJobId, {
      jobData: bulkUpdateJobData,
      isLoading: false,
    });
  },
  [Actions.VALIDATE_BULK_UPDATE_JOB_SUCCESS]: (state, { bulkUpdateJobId, validationErrors }) => {
    return updateBulkJobId(state, bulkUpdateJobId, { validationErrors });
  },
  [Actions.UPDATE_BULK_UPDATE_JOB]: (state, { bulkUpdateJobId, propertiesToUpdate }) => {
    return updateBulkJobId(state, bulkUpdateJobId, propertiesToUpdate);
  },
  [Actions.BULK_UPDATE_SET_MODEL]: (state, { bulkUpdateJobId, model }) => {
    return updateBulkJobId(state, bulkUpdateJobId, { model });
  },
  [Actions.BULK_UPDATE_REQUEST_SUCCESS]: (state, { bulkUpdateJobId }) => {
    return updateBulkJobId(state, bulkUpdateJobId, { isLoading: true });
  },
  [Actions.DELETE_BULK_UPDATE_JOB]: (state, { bulkUpdateJobId }) => {
    const { jobIdtoJobMap } = state;
    const clonedJobIdToJobMap = { ...jobIdtoJobMap };
    delete clonedJobIdToJobMap[bulkUpdateJobId];
    return {
      ...state,
      jobIdtoJobMap: clonedJobIdToJobMap,
    };
  },
  [Actions.BULK_UPDATE_READ_SCALE_REQUEST]: (state, { requestId }) => {
    return {
      ...state,
      bulkUpdateReadScaleRequestId: requestId,
    };
  },
  [Actions.SET_CARRIER_AND_CONFIRMATION_TYPES]: (state, { bulkUpdateJobId, carrierId, confirmationTypes }) => {
    const { jobIdtoJobMap } = state;
    const currentJob = jobIdtoJobMap[bulkUpdateJobId];
    return {
      ...state,
      jobIdtoJobMap: {
        ...jobIdtoJobMap,
        [bulkUpdateJobId]: {
          ...currentJob,
          carrierId,
          confirmationTypes,
        },
      },
    };
  },
  [Actions.INITIALIZE_ZERO_WEIGHT_BULK_UPDATE]: (state, { sellerDefaultWeightUnit }) => {
    const { jobIdtoJobMap } = state;
    const currentJob = jobIdtoJobMap[drawerBulkUpdateJobId];
    const currentShippingConfig = get(currentJob, 'model.shippingConfiguration') || {};
    // setting weightUnit to 'Ounces' should be fine as downstream components will read out the seller setting
    // and apply it when the weight is adjusted. I did it this way instead of reading out of global selectors
    const firstPackage = {
      ...(get(currentShippingConfig, 'packages.0') || {}),
      weight: {
        weight: 0,
        weightUnit: sellerDefaultWeightUnit,
      },
    };
    const shippingConfiguration = {
      ...currentShippingConfig,
      packages: [
        {
          ...firstPackage,
        },
      ],
    };
    const propertiesToUpdate = { model: { shippingConfiguration } };
    return {
      ...updateBulkJobId(state, drawerBulkUpdateJobId, propertiesToUpdate),
    };
  },
  [ConnectActions.READ_CONVERTED_SCALE_RESPONSE]: (state, { requestId, weight, weightUnit }) => {
    const { bulkUpdateReadScaleRequestId, jobIdtoJobMap } = state;
    const hasKeyInBulkUpdateJobs = jobIdtoJobMap[requestId] !== undefined;
    if (bulkUpdateReadScaleRequestId === requestId || hasKeyInBulkUpdateJobs) {
      const bulkUpdateJobId = hasKeyInBulkUpdateJobs ? requestId : drawerBulkUpdateJobId;

      const currentJob = state.jobIdtoJobMap[bulkUpdateJobId] || {};
      const currentPackages = currentJob?.model?.shippingConfiguration?.packages || [{}];
      const propertiesToUpdate = {
        model: {
          ...(currentJob?.model || {}),
          shippingConfiguration: {
            ...(currentJob?.model?.shippingConfiguration || {}),
            packages: currentPackages.map((pack) => {
              return {
                ...pack,
                weight: { weight, weightUnit },
              };
            }),
          },
        },
      };
      return {
        ...updateBulkJobId(state, bulkUpdateJobId, propertiesToUpdate),
        bulkUpdateReadScaleRequestId: undefined,
      };
    }
    return state;
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './bulk.update.reducer.metadata';
